import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";

export const sentimentDissatisfied = (props) => {
  return <SentimentDissatisfiedIcon {...props} />;
};
